/**
 * BuildScenarioRowInputStyles - Styled components for the scenario row input component.
 *
 * ARCHITECTURE:
 * - Provides styling for input fields.
 * - Integrates with the existing theme system.
 */

import styled from '@emotion/styled'
import { StandardInput } from '../../../../../../ui_reusable/StandardInputs'

// Container styling - horizontal stack
export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`

// Input field styling
export const SliderInput = styled(StandardInput)`
  width: 120px;
  text-align: center;
`
